import { z } from 'zod';
import { UserSchema, UserTypeSchema, UserStatusSchema, UserClassificationSchema, refineExternalMember } from '../../entities/user/user.schema';
import { ErrorCode } from '../../shared/error-codes';
import { SupportedLanguageSchema } from '../../shared/language.schema';
/**
 * Update Org Member Request Schema
 * PATCH /api/v2/org-members/:id
 */ export const UpdateOrgMemberRequestSchema = z.object({
    firstName: z.string().min(1, ErrorCode.FIELD_REQUIRED).optional(),
    lastName: z.string().min(1, ErrorCode.FIELD_REQUIRED).optional(),
    email: z.string().email(ErrorCode.FIELD_INVALID_EMAIL).optional(),
    // min(1): '' is neither a valid id nor the clear convention — reject it
    // instead of letting it reach ObjectId parsing on the server (500).
    department: z.string().min(1, ErrorCode.FIELD_REQUIRED).optional(),
    // OrgFunction id of the user's Stelle (must be a role-kind OrgFunction).
    // null = clear the stored mainRole (server translates to $unset).
    mainRole: z.string().min(1, ErrorCode.FIELD_REQUIRED).nullable().optional(),
    secondaryRoles: z.array(z.string()).optional(),
    // null = clear the stored location (server translates to $unset).
    location: z.string().trim().min(1).nullable().optional(),
    userTypes: z.array(UserTypeSchema).optional(),
    status: UserStatusSchema.optional(),
    classification: UserClassificationSchema.optional(),
    externalOrganization: z.string().optional(),
    language: SupportedLanguageSchema.optional()
}).superRefine((data, ctx)=>{
    // Disallow department when classification is 'external'
    if (data.classification === 'external' && data.department) {
        ctx.addIssue({
            code: 'custom',
            message: ErrorCode.EXTERNAL_MEMBER_NO_DEPARTMENT,
            path: [
                'department'
            ]
        });
    }
    // External members: externalOrganization required, plus the role rule when
    // userTypes is in the payload. Partial PATCH (userTypes omitted) is judged
    // authoritatively by the update validator against the stored document.
    refineExternalMember(ctx, data, {
        partial: true
    });
});
/**
 * Update Org Member Response Schema
 * PATCH /api/v2/org-members/:id
 */ export const UpdateOrgMemberResponseSchema = z.object({
    data: UserSchema
});

//# sourceMappingURL=update-org-member.schema.js.map